<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import TrackFull from './shared/TrackFull.vue'

defineProps({
  item: Object,
})
</script>

<template>
  <ToFullTopLeft>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :scale="3" :position="{ x: -568, y: -898 }" :backgroundColor="colors.q.cr.red.primary" :color="colors.q.cr.red.darker">
      <TrackFull label="Nu" :track="item.enrichment.track" withIntro />
    </AnimatedBackground>
  </ToFullTopLeft>
</template>
